import { Facebook } from "lucide-react";
import { API } from "../../lib/api";

export const journeyShareUrl = (fr) => `${API}/share/litter-journey${fr ? "?lang=fr" : ""}`;

export const JourneyShareButton = ({ fr, testid = "journey-share-fb-btn", className = "" }) => {
  const share = () => {
    const u = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(journeyShareUrl(fr))}`;
    window.open(u, "fb-share", "width=640,height=560,noopener");
  };
  return (
    <button type="button" onClick={share} data-testid={testid}
      className={`h-10 rounded-xl bg-[#1877F2] hover:bg-[#166FE5] text-white text-sm font-semibold px-4 inline-flex items-center gap-1.5 transition-colors ${className}`}>
      <Facebook size={15} /> {fr ? "Partager sur Facebook" : "Share on Facebook"}
    </button>
  );
};
